import React from 'react';
import { InputText } from 'primereact/inputtext';
import InsurerSearchDropdown from './InsurerSearchDropdown';

interface InsurerNaicFieldProps {
  name: string;
  id: string | null;
  naic: string;
  onNameChange: (name: string) => void;
  onIdChange: (id: string | null) => void;
  onNaicChange: (naic: string) => void;
  className?: string;
}

// Tracker #257 (Farmers, 10/9): a carrier field with an editable NAIC # beside it. Picking a
// carrier from the list fills both; the agent can then overwrite either. On Save, a name that
// matches no carrier, or an NAIC that differs from the picked carrier's, creates a new carrier
// in the AMS (see utils/carrierSlots.ts), so the certificate still prints by carrier id.
const InsurerNaicField: React.FC<InsurerNaicFieldProps> = ({ name, id, naic, onNameChange, onIdChange, onNaicChange, className }) => (
  <div className="masterCert__insurerPair">
    <InsurerSearchDropdown
      value={name}
      valueId={id}
      onChange={onNameChange}
      onIdChange={onIdChange}
      onPick={(o) => onNaicChange(o.naic)}
      className={className}
    />
    <InputText
      value={naic}
      onChange={(e) => onNaicChange(e.target.value)}
      placeholder="NAIC #"
      maxLength={10}
      aria-label="NAIC #"
      className="masterCert__input masterCert__insurerNaic"
    />
  </div>
);

export default InsurerNaicField;
